import { DOMAIN_TYPE } from 'store/page/constants';

const DOMAIN_NAME = 'improvements';

export const SET_ACTIVE_TAB_ID =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_ACTIVE_TAB_ID` as const;

// Shared filter state — improvement-area chip selection. Persists across the
// Suggestions/Actions tab switch. Empty array means "show all".
// The sentinel 'unassigned' represents rows with a null improvementAreaId.
export const SET_SELECTED_AREA_IDS =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_SELECTED_AREA_IDS` as const;
export const TOGGLE_SELECTED_AREA_ID =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/TOGGLE_SELECTED_AREA_ID` as const;

// Sentinel id for suggestions/actions without an assigned improvement area.
// Used inside `selectedAreaIds` so the existing string[] state shape works for
// both real area ids and the "unassigned" bucket.
export const UNASSIGNED_AREA_ID = 'unassigned' as const;

// ==========================
// Actions Sagas / Constants
// ==========================
export const MOCKED_ACTION_ID = 'mocked-suggestion' as const;

export const SET_SELECTED_ACTION_ID =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_SELECTED_ACTION_ID` as const;

export const START_UPDATE_ACTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_UPDATE_ACTION` as const;

export const START_DELETE_ACTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_DELETE_ACTION` as const;

export const START_CREATE_MOCK_ACTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_CREATE_MOCK_ACTION` as const;

export const START_ADD_ACTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_ADD_ACTION` as const;
// ==========================
// Suggestion Sagas / Constants
// ==========================
// constants
export const MOCKED_SUGGETION_ID = 'mocked-suggestion' as const;

export const SET_SELECTED_SUGGESTION_ID =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_SELECTED_SUGGESTION_ID` as const;

export const START_CREATE_ACTION_FROM_SUGGESTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_CREATE_ACTION_FROM_SUGGESTION` as const;
export const START_SAVE_SUGGESTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_SAVE_SUGGESTION` as const;
export const START_CREATE_MOCK_SUGGESTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_CREATE_MOCK_SUGGESTION` as const;
export const START_REJECT_SUGGESTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_REJECT_SUGGESTION` as const;
export const START_DELETE_SUGGESTION =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_DELETE_SUGGESTION` as const;

// ==========================
// Actionboard (sub-view) / Constants
// ==========================
// Actionboard holds the simulate-tab's selected week + selected entity (zone/activity).
// Migrated in from the deleted store/page/actionboard domain.
export const SET_ACTIONBOARD_SELECTED_WEEK =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_ACTIONBOARD_SELECTED_WEEK` as const;
export const SET_ACTIONBOARD_SELECTED_ENTITY_ID =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/SET_ACTIONBOARD_SELECTED_ENTITY_ID` as const;
